export default "__VITE_ASSET__DdWsyGvN__"